import { useEffect } from "react";
import useScript from "../auth/hooks/useScript";

const useKakaoInit = () => {
  const [loaded] = useScript(
    "https://developers.kakao.com/sdk/js/kakao.min.js",
  );
  useEffect(() => {
    if (loaded) {
      if (window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init("1fc213eb051592deca2aa011f5c0e5db");
      }
    }
  }, [loaded]);
  return [loaded];
};

export default useKakaoInit;
